import { render } from "./2022-10-12-Box.md?vue&type=template&id=48975164"
const script = {}
script.render = render

export default script